 	// install a JSONP callback for chunk loading
 	var parentJsonpFunction = window["webpackJsonp"];
 	window["webpackJsonp"] = function webpackJsonpCallback(chunkIds, moreModules, executeModules) {
 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [], result;
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(installedChunks[chunkId])
 				resolves.push(installedChunks[chunkId][0]);
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(chunkIds, moreModules, executeModules);
 		while(resolves.length)
 			resolves.shift()();

 	};

 	// The module cache
 	var installedModules = {};

 	// objects to store loaded and loading chunks
 	var installedChunks = {
 		18: 0
 	};

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId])
 			return installedModules[moduleId].exports;

 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		if(installedChunks[chunkId] === 0)
 			return Promise.resolve();

 		// an Promise means "currently loading".
 		if(installedChunks[chunkId]) {
 			return installedChunks[chunkId][2];
 		}
 		// start chunk loading
 		var head = document.getElementsByTagName('head')[0];
 		var script = document.createElement('script');
 		script.type = 'text/javascript';
 		script.charset = 'utf-8';
 		script.async = true;
 		script.timeout = 120000;

 		if (__webpack_require__.nc) {
 			script.setAttribute("nonce", __webpack_require__.nc);
 		}
 		script.src = __webpack_require__.p + "" + {"0":"7122f0252ab33cf4bf77","1":"81685caf4cafdeeef92b","2":"6d442fc3f68279e7ec22","3":"c131d80d56ea4b208382","4":"6862cb6b05340bddcf3e","5":"f219ed566ccb79546665","6":"b2d2ee28026eac84682c","7":"7ffe2ef0effbeb80e441","8":"e993b718da55430f0b75","9":"8a37e7222fe397f27e49","10":"0f230fac310277babbb7","11":"a337cd56c20e2f84f747","12":"e8278076138526ea91e4","13":"a8355ac95af937a7aba0","14":"d117e86f531367fa0e13","15":"e21a3daf48c7ed288f44"}[chunkId] + "/graun." + ({"0":"enhanced-no-commercial","1":"commercial","2":"ophan-embed","3":"article","4":"crosswords","5":"media","6":"enhanced","7":"facia","8":"profile","9":"membership","10":"football","13":"youtube","15":"newsletters"}[chunkId]||chunkId) + ".js";
 		var timeout = setTimeout(onScriptComplete, 120000);
 		script.onerror = script.onload = onScriptComplete;
 		function onScriptComplete() {
 			// avoid mem leaks in IE.
 			script.onerror = script.onload = null;
 			clearTimeout(timeout);
 			var chunk = installedChunks[chunkId];
 			if(chunk !== 0) {
 				if(chunk) chunk[1](new Error('Loading chunk ' + chunkId + ' failed.'));
 				installedChunks[chunkId] = undefined;
 			}
 		};

 		var promise = new Promise(function(resolve, reject) {
 			installedChunks[chunkId] = [resolve, reject];
 		});
 		installedChunks[chunkId][2] = promise;

 		head.appendChild(script);
 		return promise;
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// identity function for calling harmony imports with the correct context
 	__webpack_require__.i = function(value) { return value; };

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, {
 				configurable: false,
 				enumerable: true,
 				get: getter
 			});
 		}
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	// Load entry module and return exports
 	return __webpack_require__(__webpack_require__.s = 323);



// WEBPACK FOOTER //
// webpack/bootstrap f7bb6e70e0f4dc7ad6b1